import { render, staticRenderFns } from "./BotaoEnviarRelatorioConsumo.vue?vue&type=template&id=03f01ea4&scoped=true&"
import script from "./BotaoEnviarRelatorioConsumo.vue?vue&type=script&lang=js&"
export * from "./BotaoEnviarRelatorioConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f01ea4",
  null
  
)

export default component.exports